<template>
	<div class="card-list scrollable" :class="`display-${displayMode}`" @scroll="scroll_f">
		<div class="card-list-container">
			<div v-for="card in cards" :key="card.id" class="card-slot">
				<card
					:card="card"
					:display-mode="displayMode"
					v-model:countR0="card.owned[RANK_0_KEY]"
					v-model:countR5="card.owned[RANK_5_KEY]"
				/>
			</div>
			<div ref="fetchDummy" class="card fetch-dummy" :class="{ 'is-hidden': stopFetch }" />
		</div>
	</div>
</template>

<script>
import {
	RANK_0_KEY,
	RANK_5_KEY
} from '../utils/CardsGetter';

import Card from '../components/Card.vue';

const DEFAULT_FROM = 0;
const DEFAULT_SIZE = 10;

export default {
	name: 'card-list',
	expose: [ 'reset' ],
	components: {
		Card
	},
	props: {
		dataGetter: {
			type: Function,
			required: true
		},
		'display-mode': {
			type: String,
			validator(value) {
				return [ 'grid', 'list' ].includes(value);
			},
			default: 'list'
		}
	},
	data() {
		return {
			from: DEFAULT_FROM,
			size: DEFAULT_SIZE,
			cards: [],
			fetching: false,
			stopFetch: false
		};
	},
	computed: {
		scroll_f() {
			return !this.stopFetch ? this.onScroll : null;
		},
		RANK_0_KEY() {
			return RANK_0_KEY;
		},
		RANK_5_KEY() {
			return RANK_5_KEY;
		}
	},
	mounted() {
		this.reset();
	},
	methods: {
		onScroll() {
			// check fetch dummy's visibility
			const rect = this.$refs.fetchDummy.getBoundingClientRect();
			const viewHeight = document.documentElement?.clientHeight ?? window.innerHeight ?? 0;
			const dummyInSight = !(rect.bottom < 0 || rect.top - viewHeight >= 0); // AY CAP'TAIN !
			if (dummyInSight)
				this.updateData();
		},
		reset() {
			this.from = DEFAULT_FROM;
			this.size = DEFAULT_SIZE;
			this.cards = [];
			this.$el.scrollTop = 0;
			this.updateData();
		},
		updateData() {
			if (this.fetching) // future async preparation
				return;
			this.fetching = true;
			const newCards = this.dataGetter(this.from, this.size);
			this.cards.splice(this.cards.length, 0, ...newCards);
			this.from += newCards.length;
			this.stopFetch = newCards.length < this.size;
			this.fetching = false;
			this.$nextTick(() => {
				if (!this.stopFetch)
					this.onScroll();
			});
		}
	}
};
</script>

<style lang="scss">

.card-list {
	height: 100%;
	width: 100%;

	&.display-grid {
		>.card-list-container {
			width: 100%;
			padding: 15px 0;
			display: grid;
			grid-column-gap: 15px;
			grid-row-gap: 15px;
			grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
			justify-items: center;
		}
	}
	&.display-list {
		>.card-list-container {
			.card-slot {
				width: 100%;
				padding: 0 10px;
				&:not(:last-child) {
					padding-top: 10px;
				}
				&:last-child {
					padding-bottom: 10px;
				}
			}
		}
	}
}

.is-hidden {
	display: none;
}

</style>
